<div class='feedBack' *ngIf='show' [ngStyle]="{ 'z-index': index }" [ngClass]="{'layer':!noMask}">
  <div class='feedBack-body flexColumn' [ngStyle]='bodyStyle'>
    <div class='feedBack-title-box flexRow'>
      <div class='feedBack-title'>{{ title }}</div>
      <i nz-icon nzType='close' nzTheme='outline' class='feedBack-close clickEle' *ngIf='closeIcon'
         (click)='clickCancel()'></i>
    </div>
    <div class='feedBack-content-box flexFull'>
      <ng-container [ngTemplateOutlet]='body'></ng-container>
    </div>
    <div class='feedBack-button-box flexRow border-top-1' *ngIf='showBottom'>
      <div class='flexFull'></div>
      <ng-container *ngFor='let button of otherButton'>
        <button nz-button nzType="{{ button['type'] }}" class='weakButton' (click)="clickOther(button['sign'])">
          {{ button['text'] }}
        </button>
      </ng-container>
      <button nz-button nzType='default' class='weakButton' (click)='clickCancel()'
              *ngIf='showCancel'>{{ cancelText }}</button>
      <button nz-button nzType='primary' class='sureButton' (click)='clickSure()'
              *ngIf='showSure'>{{ sureText }}</button>
    </div>
  </div>
</div>
